<template>
  <el-select v-if="!multiple" v-model="computedValue" placeholder="Selecciona" :disabled="disabled">
    <el-option-group v-for="group in filteredOperators" :key="group.label" :label="group.label">
      <el-option v-for="item in group.options" :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-option-group>
  </el-select>
  <MultipleSelect v-else v-model="computedValue" :items="operators" item-label="name" />
</template>

<script>
import cache from "@/mixins/cache";
import { mapActions, mapGetters } from "vuex";
import { sortByName } from "@/utils/sorters";
import MultipleSelect from "./MultipleSelect.vue";
import { isAreaSanitariaDeVigo } from "@/utils/user-types";

export default {
  name: "OperatorSelect",
  mixins: {
    cache,
  },
  components: {
    MultipleSelect,
  },
  props: {
    value: [Number, Array],
    disabled: Boolean,
    multiple: Boolean,
  },
  data() {
    return {
      operators: [],
    };
  },
  async created() {
    if (!this.cached) {
      this.operators = await this.getOperators({
        ccenterId: this.callCenter.id,
      });
    }
  },
  computed: {
    ...mapGetters("app", ["callCenter"]),
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    filteredOperators() {
      if (isAreaSanitariaDeVigo()) {
        return [
          {
            options: (this.operators || [])
              .filter((o) => !o.deleted)
              .filter((a) => a.user.includes("areasanitariavigo"))
              .sort(sortByName),
          },
        ];
      }
      return [
        {
          options: (this.operators || []).filter((o) => !o.deleted).sort(sortByName),
        },
        {
          label: "Eliminados",
          options: (this.operators || []).filter((o) => o.deleted).sort(sortByName),
        },
      ];
    },
  },
  methods: {
    ...mapActions("operators", ["getOperators"]),
  },
};
</script>

<style></style>
